import { Autocomplete, InputAdornment, TextField } from "@mui/material";
import React from "react";

import BusinessIcon from "@mui/icons-material/Business";
import { useState } from "react";
import { MedioContactoClienteArray } from "../../Arrays/MedioContactoArray";
import { TipoPersonaArray } from "../../Arrays/TipoPersonaArray";
import { SexoArray } from "../../Arrays/SexoArray";
import { RegimenConyugalArray } from "../../Arrays/RegimenConyugalArray";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { ClienteDatosGeneralesValidate } from "./Ctl-Clientes/ClientesDatosGeneralesValidate";
import request from "../../Helpers/API";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { types } from "../../Helpers/Types";
import { RegimenFiscalArrayMayusculas } from "../../Arrays/RegimenFiscal";
import { estadoCivilArrayMayusculas } from "../../Arrays/EstadoCivilArray";

export const ClientesDatosGenerales = ({ disabled, setLoading }) => {
  const { idcliente } = useSelector((store) => store.clientes);
  const dispatch = useDispatch();
  const [vendedores, setVendedores] = useState([]);
  const [state, setState] = useState({
    razonsocial: "",
    rfc: "",
    tipopersona: "",
    mediocontacto: "",
    tiempoagricultor: 0,
    regimenfiscal: "",
    idvendedor: "",
    nombre: "",
    nombre2: "",
    apellidopaterno: "",
    apellidomaterno: "",
    curp: "",
    sexo: "",
    estadocivil: "",
    regimenconyugal: "",
    referenciabancaria: "",
    edad: 0,
    fecha: new Date(),
  });

  useEffect(() => {
    if (idcliente !== undefined && idcliente !== null && idcliente > 0) {
      setLoading(true);
      request
        .get(`Clientes/BuscarID?idcliente=${Number(idcliente)}`)
        .then((result) => {
          setLoading(false);
          setState({
            razonsocial: result.razon_social,
            rfc: result.rfc,
            tipopersona: result.tipo_persona,
            mediocontacto: result.medio_contacto,
            tiempoagricultor: result.tiempo_agricultor,
            regimenfiscal: result.regimen_fiscal,
            nombre: result.nombre,
            nombre2: result.nombre2,
            apellidopaterno: result.apellido_paterno,
            apellidomaterno: result.apellido_materno,
            curp: result.curp,
            sexo: result.sexo,
            estadocivil: result.estado_civil,
            regimenconyugal: result.regimen_conyugal,
            referenciabancaria: result.referencia,
            edad: result.edad,
            idvendedor: result.idvendedor,
          });
        })
        .catch(async (error) => {
          setLoading(false);
          await Swal.fire("Clientes", JSON.stringify(error), "success");
        });
    } else {
      setState({
        razonsocial: "",
        rfc: "",
        tipopersona: "",
        mediocontacto: "",
        tiempoagricultor: 0,
        regimenfiscal: "",
        idvendedor: "",
        nombre: "",
        nombre2: "",
        apellidopaterno: "",
        apellidomaterno: "",
        curp: "",
        sexo: "",
        estadocivil: "",
        regimenconyugal: "",
        referenciabancaria: "",
        edad: 0,
      });
    }
  }, [idcliente]);
  useEffect(() => {
    setLoading(true);
    request
      .get("DDLVendedor/Listado")
      .then((result) => {
        setLoading(false);
        setVendedores(result);
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire("CLIENTES", JSON.stringify(error), "error");
      });
  }, []);
  const onGuardar = () => {
    var result = ClienteDatosGeneralesValidate(state);
    if (result === undefined || result === null || result === false) return;

    setLoading(true);
    result.idcliente = idcliente;

    const endpoint =
      result.tipo_persona === "M"
        ? "Clientes/Persona_Moral"
        : "Clientes/Persona_Fisica";

    request
      .post(endpoint, result)
      .then(async () => {
        setLoading(false);
        await Swal.fire("Clientes", "Datos cargados con exito", "success");
        setState({
          razonsocial: "",
          rfc: "",
          tipopersona: "",
          mediocontacto: "",
          tiempoagricultor: 0,
          regimenfiscal: "",
          idvendedor: "",
          nombre: "",
          nombre2: "",
          apellidopaterno: "",
          apellidomaterno: "",
          curp: "",
          sexo: "",
          estadocivil: "",
          regimenconyugal: "",
          referenciabancaria: "",
          edad: 0,
        });
        dispatch({
          type: types.clientes,
          payload: {
            clienteinput: "",
            clienteselected: "",
            idcliente: 0,
            clientesArray: [],
            disabled: true,
          },
        });
      })
      .catch(async (error) => {
        setLoading(false);
        await Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };
  const onCalcularRFC = () => {
    if (
      state.razonsocial === undefined ||
      state.razonsocial === null ||
      state.razonsocial === ""
    ) {
      Swal.fire(
        "Clientes",
        "Favor de indicar la fecha de nacimiento (Persona Fisica) o la fecha de constitución de la empresa (Persona Moral)",
        "warning"
      );
      return;
    }
    if (
      state.fecha === undefined ||
      state.fecha === null ||
      state.fecha === ""
    ) {
      Swal.fire(
        "Clientes",
        "Favor de indicar la fecha de nacimiento (Persona Fisica) o la fecha de constitución de la empresa (Persona Moral)",
        "warning"
      );
      return;
    }
  };

  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  };
  return (
    <div className="fuentes-roboto-fs12 ">
      <div className="container-clientes-datos-generales scroll-4">
        <div className="clientes-form-2-controls">
          <TextField
            disabled={disabled}
            fullWidth
            label="Razón Social"
            size="small"
            color="success"
            className="w-66"
            value={capitalizeWords(state.razonsocial)}
            onChange={({ target }) =>
              setState({ ...state, razonsocial: target.value.toUpperCase() })
            }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <BusinessIcon />
                </InputAdornment>
              ),
            }}
            inputProps={{
              maxLength: 100,
            }}
          />
          <TextField
            disabled={disabled}
            label="RFC"
            size="small"
            color="success"
            className={Number(idcliente) === -110 ? "w-22" : "w-33"}
            value={state.rfc}
            onChange={({ target }) =>
              setState({
                ...state,
                rfc: target.value.toUpperCase(),
              })
            }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <BusinessIcon />
                </InputAdornment>
              ),
            }}
            inputProps={{
              maxLength: 13,
            }}
          />
          {idcliente === "AAA" ||
            (Number(idcliente) === -110 && <button>Generar RFC</button>)}
        </div>

        <div className="clientes-form-2-controls">
          <Autocomplete
            disabled={disabled}
            fullWidth
            size="small"
            id="regimenfiscal"
            freeSolo
            className="w-66"
            value={state.regimenfiscal}
            onChange={({ target }) =>
              setState({ ...state, regimenfiscal: target.outerText })
            }
            options={RegimenFiscalArrayMayusculas.map(
              (option) => `${option.id} - ${option.display}`
            )}
            renderInput={(params) => (
              <TextField {...params} label="Régimen Fiscal" />
            )}
            sx={{ mr: 1 }}
          />
          <TextField
            label="Referencia Bancaria"
            size="small"
            color="success"
            disabled
            className="w-33"
            value={state.referenciabancaria}
            onChange={({ target }) =>
              setState({
                ...state,
                referenciabancaria: target.value.toUpperCase(),
              })
            }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountBalanceIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <Autocomplete
          disabled={disabled}
          fullWidth
          size="small"
          id="vendedor"
          freeSolo
          className="w-66"
          value={state.idvendedor}
          onChange={({ target }) =>
            setState({ ...state, idvendedor: target.outerText })
          }
          options={vendedores.map(
            (option) => `${option.idvendedor} - ${option.vendedor}`
          )}
          renderInput={(params) => <TextField {...params} label="Vendedor" />}
          sx={{ mr: 1, mt: 2 }}
        />
        <div className="clientes-form-2-controls">
          <Autocomplete
            disabled={disabled}
            size="small"
            id="mediodecontacto"
            freeSolo
            className="w-66"
            value={state.mediocontacto}
            onChange={({ target }) =>
              setState({ ...state, mediocontacto: target.outerText })
            }
            options={MedioContactoClienteArray.map(
              (option) => `${option.id} - ${option.display}`
            )}
            renderInput={(params) => (
              <TextField {...params} label="Medio de Contacto Preferido" />
            )}
          />
          <Autocomplete
            disabled={disabled}
            size="small"
            id="tipocliente"
            freeSolo
            className="w-33"
            value={state.tipopersona}
            onChange={({ target }) =>
              setState({ ...state, tipopersona: target.outerText })
            }
            options={TipoPersonaArray.map(
              (option) => `${option.id} - ${option.display}`
            )}
            renderInput={(params) => (
              <TextField {...params} label="Tipo de Régimen" />
            )}
          />
        </div>
        {state.tipopersona === "F - Fisica" ? (
          <div className="persona-fisica">
            <div className="clientes-form-3-controls">
              <TextField
                disabled={disabled}
                label="Primer Nombre"
                size="small"
                color="success"
                className="w-66"
                value={capitalizeWords(state.nombre)}
                onChange={({ target }) =>
                  setState({ ...state, nombre: target.value.toUpperCase() })
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircleIcon />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  maxLength: 50,
                }}
              />
              <TextField
                disabled={disabled}
                label="Segundo Nombre"
                size="small"
                color="success"
                className="w-33"
                value={capitalizeWords(state.nombre2)}
                onChange={({ target }) =>
                  setState({ ...state, nombre2: target.value.toUpperCase() })
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircleIcon />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  maxLength: 50,
                }}
              />
            </div>
            <div className="clientes-form-2-controls">
              <TextField
                disabled={disabled}
                label="Apellido Paterno"
                size="small"
                color="success"
                className="w-66"
                value={capitalizeWords(state.apellidopaterno)}
                onChange={({ target }) =>
                  setState({
                    ...state,
                    apellidopaterno: target.value.toUpperCase(),
                  })
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircleIcon />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  maxLength: 50,
                }}
              />
              <TextField
                disabled={disabled}
                label="Apellido Materno"
                size="small"
                color="success"
                className="w-33"
                value={capitalizeWords(state.apellidomaterno)}
                onChange={({ target }) =>
                  setState({
                    ...state,
                    apellidomaterno: target.value.toUpperCase(),
                  })
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircleIcon />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  maxLength: 50,
                }}
              />
            </div>
            <div className="clientes-form-3-controls">
              <TextField
                disabled={disabled}
                label="CURP"
                size="small"
                color="success"
                className="w-66"
                value={state.curp}
                onChange={({ target }) =>
                  setState({ ...state, curp: target.value.toUpperCase() })
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircleIcon />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  maxLength: 18,
                }}
              />
              {/* <TextField
              disabled={disabled}
              label="Edad"
              size="small"
              color="success"
              type="number"
              className="w-33"
              value={state.edad}
              onChange={({ target }) =>
                setState({ ...state, edad: target.value })
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircleIcon />
                  </InputAdornment>
                ),
              }}
            /> */}
              <Autocomplete
                disabled={disabled}
                size="small"
                id="sexo"
                freeSolo
                className="w-33"
                value={state.sexo}
                onChange={({ target }) =>
                  setState({ ...state, sexo: target.outerText })
                }
                options={SexoArray.map(
                  (option) => `${option.id} - ${option.display}`
                )}
                renderInput={(params) => <TextField {...params} label="Sexo" />}
              />
            </div>
            <div className="clientes-form-2-controls">
              <Autocomplete
                disabled={disabled}
                size="small"
                id="estadocivil"
                freeSolo
                className="w-66"
                value={state.estadocivil}
                onChange={({ target }) =>
                  setState({ ...state, estadocivil: target.outerText })
                }
                options={estadoCivilArrayMayusculas.map(
                  (option) => `${option.id} - ${option.display}`
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Estado Civil" />
                )}
              />
              <Autocomplete
                disabled={state.estadocivil !== "CA - CASADO" ? true : disabled}
                size="small"
                id="regimenconyugal"
                freeSolo
                className="w-33"
                value={
                  state.estadocivil !== "CA - CASADO"
                    ? ""
                    : state.regimenconyugal
                }
                onChange={({ target }) =>
                  setState({ ...state, regimenconyugal: target.outerText })
                }
                options={RegimenConyugalArray.map(
                  (option) => `${option.id} - ${option.display}`
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Regimen Conyugal" />
                )}
              />
            </div>
          </div>
        ) : (
          <></>
        )}
        <div className="clientes-form-footer">
          <div
            onClick={() => onGuardar()}
            className="clientes-form-button-guardar"
          >
            Guardar
          </div>
        </div>
        <div className="modal-calcula-rfc">
          <div className="modal-calcula-rfc-container">
            <span className="close-modal-rfc">X</span>
            <header>Calcular RFC</header>
            <main>
              <TextField
                fullWidth
                label="Razon Social"
                size="small"
                color="success"
                className="w-66"
                value={state.razonsocial}
                onChange={({ target }) =>
                  setState({
                    ...state,
                    razonsocial: target.value.toUpperCase(),
                  })
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <BusinessIcon />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  maxLength: 100,
                }}
              />
              <TextField
                fullWidth
                label="Fecha de nacimiento o creación de la empresa"
                size="small"
                color="success"
                type="date"
                className="w-66"
                value={state.fecha}
                onChange={({ target }) =>
                  setState({ ...state, fecha: target.value.toUpperCase() })
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <BusinessIcon />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  maxLength: 100,
                }}
                sx={{
                  mt: 2,
                }}
              />
              <button onClick={onCalcularRFC}>Calcular</button>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};
